<template>
  <main>
    <section class="video-intro">
      <h1>Contrology Event Video</h1>
    </section>

    <nav>
      <router-link to="event-videos" title="See all event videos"><img src="@/assets/icon-standard-arrow-left.svg" alt="Back arrow icon">all videos</router-link>
    </nav>

    <div class="video-container">
      <iframe title="This is an embedded iframe video" width="996" height="560" src="https://www.youtube.com/embed/I776JTsgPRs" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    </div>

    <div class="wide-flex-wrapper">
      <section class="video-description">
        <h2>The Contrology Lab: Building the Pull Up</h2>
        <p>Original Air Date: Friday, January 31, 2025</p>
        <p>
          Join Nicole Briggs, as she explores pull up progressions around the Contrology studio.
          <br><br>
          Guest panelists: Laurel and Louie Foley of Eclipse Classical Pilates
        </p>
        <p>Runtime: 0:58:09</p>
      </section>

      <hr>

      <section class="video-speakers">
        <h3>Featured Speaker</h3>
        
        <div class="video-speaker">
          <img src="https://s3.amazonaws.com/s3.pilates.com/contrology/contrology-lab-nicole-briggs@1x.jpg" srcset="https://s3.amazonaws.com/s3.pilates.com/contrology/contrology-lab-nicole-briggs@2x.jpg 2x" alt="Nicole Briggs headshot">
          <div class="video-speaker-content">
            <p><b>Nicole Briggs</b></p>
            <p style="white-space:nowrap">Indianapolis, Indiana</p>
          </div>
        </div>
      </section>
    </div>
    
  </main>
</template>

<script>
  export default {
    name: "building-pull-up",

    metaInfo: {
      title: "The Contrology Lab: Building the Pull Up",
      titleTemplate: "%s",
      meta: [
        {
          name: "description",
          content: "Join Nicole Briggs, as she explores pull up progressions around the Contrology studio."
        },
        {
          property: "og:image",
          content: "https://s3.amazonaws.com/s3.pilates.com/contrology/logo-contrology-lab.png"
        }
      ]
    },
  }
</script>

<style lang="scss" scoped>
nav {
  display: flex;
  flex-flow: column nowrap;
  margin: 20px 0 30px;
  max-width: 996px;
  margin: 0 auto;
}

nav a {
  text-transform: uppercase;
  font-family: var(--rob);
  font-size: 1.125rem;
  line-height: 1.278;
  font-weight: 700;
  color: #333;
  text-decoration: none;
  padding: 7px 0;
  display: flex;
  justify-content: flex-start;
}

nav img {
  margin-right: 15px;
}

.video-container { 
  position: relative; 
  padding-bottom: 56.25%; 
  padding-top: 30px; 
  height: 0; 
  overflow: hidden; 
  max-width: 996px;
  margin: 0 auto 40px;
}

.video-container iframe,
.video-container object,
.video-container embed { 
  position: absolute; 
  top: 0; 
  left: 0; 
  width: 100%; 
  height: 100%;
  max-height: 560px;
}

.video-description p {
  font-size: 0.9375rem;
  line-height: 1.4667;
}

hr {
  border: 0;
  border-top: 1px solid #333;
  width: 100%;
  margin: 30px 0;
}

h3 {
  text-align: left;
}

.video-speakers {
  width: 275px;
  margin: 0 auto;
}

.video-speaker {
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  margin-bottom: 12px;
}

.video-speaker img {
  width: 100px;
  height: 100px;
  display: block;
  margin-right: 12px;
}

.video-speaker-content p {
  margin: 0 0 10px 0;
}

.video-speaker-content p a {
  color: #000;
}

ol li {
  margin: 10px 0;
}

@media only screen and (max-width:374px) {
  .video-speakers {
    width: 250px;
    margin: -10px
  }
}

@media only screen and (min-width:800px) {
  .video-intro {
    margin: 0 auto;
  }

  .wide-flex-wrapper {
    display: flex;
    flex-flow: row nowrap;
    width: 100%;
    max-width: 750px;
    margin: 0 auto;
  }

  hr {
    display: none;
  }

  .video-description {
    margin-right: 40px;
  }
}

@media only screen and (min-width:955px) {
  .video-intro {
    max-width: 650px;
  }
}

@media only screen and (min-width:1080px) {
  .video-container { 
    padding-bottom: 0;
    height: 560px;
  }
}
</style>